export default __webpack_public_path__ + "static/media/keshis.066c9f86.png";